import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { SparklesIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import { Button, Card, Text, toast } from '@/shared/ui';
import { EmptyAIAssessmentCard } from './EmptyAIAssessmentCard';

type Props = {
  alreadyExecutionAIAssessment: boolean;
  comment: string;
};

/**
 * AI査定の空状態カードコンポーネント
 * AI査定が未実行の場合に表示する
 */
export const AIAssessmentCard = ({ alreadyExecutionAIAssessment, comment }: Props) => {
  const { t } = useTranslation();

  if (!alreadyExecutionAIAssessment) {
    return <EmptyAIAssessmentCard />;
  }

  return (
    <Card variant="accent" className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <SparklesIcon className="h-4 w-4 text-text-accent" />
        <Text color={'accent'} variant="label">
          {t('assessment.messages.ai-result-title')}
        </Text>
      </div>
      <Text>{comment}</Text>
      <div>
        <Button
          variant="outline"
          onClick={() => {
            navigator.clipboard.writeText(comment);
            toast.success(t('ai.analysis.copy-success'));
          }}
        >
          <div className="flex items-center gap-2">
            <ClipboardDocumentIcon className="size-2" />
            <Text>{t('common.actions.copy')}</Text>
          </div>
        </Button>
      </div>
    </Card>
  );
};
